export const AUTH_ORIGIN_MISMATCH_CODE = 'AUTH_ORIGIN_MISMATCH';
export const INVALID_AUTH_TOKEN_CODE = 'INVALID_AUTH_TOKEN';

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

const hasResponseCode = (error: unknown, status: number, code: string): boolean => {
    if (!isRecord(error) || !isRecord(error.response)) {
        return false;
    }

    const { data, status: responseStatus } = error.response;
    return responseStatus === status && isRecord(data) && data.code === code;
};

export function isAuthOriginMismatchError(error: unknown): boolean {
    return hasResponseCode(error, 403, AUTH_ORIGIN_MISMATCH_CODE);
}

export function isInvalidAuthTokenError(error: unknown): boolean {
    return hasResponseCode(error, 401, INVALID_AUTH_TOKEN_CODE);
}
